import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

interface CharterData {
  charterStartDate: Date;
  charterEndDate: Date;
  startLocationId: string;
  endLocationId: string;
}

const updateBookingCharterData = async (offerYachtId: string, charterData: CharterData) => {
  return fetch(`/api/bookings/charter-data/${+offerYachtId}`, "PATCH", { charterData });
};

export const useBookingCharterDataMutation = (bookingId: string, offerYachtId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { charterData: CharterData; toastId: any }) =>
      updateBookingCharterData(offerYachtId, data.charterData),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Charter data updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update booking charter data!",
        variant: "destructive",
      });
    },
  });
};
